import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AuthService } from '../../../services/auth.service';
import { ProfileService } from '../../../services/profile.service';

@Component({
  selector: 'app-user-menu',
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class UserMenuComponent {
  isCollapsed = false;

  constructor(
    private auth: AuthService,
    private profileService: ProfileService
  ) {}

  logoutWarning(): void {
    this.profileService.showLogout();
  }

  get canShowTransaction(): boolean {
    return this.auth.canSeeTransactions;
  }

  get canShowPaymentPage(): boolean {
    return this.auth.canSeePaymentMethods;
  }

  get canShowBudgets(): boolean {
    return this.auth.canSeeBudgets;
  }

  get canShowCustomRequestPage(): boolean {
    return this.auth.canCustomRequest;
  }

  get canSeeOrders(): boolean {
    return this.auth.canSeeOrders;
  }

  get canSeeAddresses(): boolean {
    return this.auth.canSeeAddresses;
  }

  get canSeeRepairRequests(): boolean {
    return this.auth.canSeeRepairRequests;
  }
}
